import axios from 'axios';
import qs from 'qs';
import router from '../router';
import { Message, MessageBox } from 'element-ui';
import utils from '../utils/utils'
// create an axios instance
const service = axios.create({
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 180000, // request timeout
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
});
service.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    },
);
// response interceptor
service.interceptors.response.use(
    (response) => {
        if (response.config.url.indexOf('sysConfig/upload') < 0) {
            //console.log(response)
            const res = response.data;
            if (res && res.code !== 0) {
                if (response.config.url.indexOf('wechat/publicxiaochengxu') > 0){
                    let msg = utils.errCoode2Msg(res.code);
                    MessageBox.alert(msg, '提示').then(() => {
                    });
                }else if (res.code !== 1) {
                    MessageBox.alert(res.msg, '提示').then(() => {
                    });
                }
                return Promise.reject(res)
            }
            if (res && res.obj && res.obj.errcode && res.obj.errcode > 0) {
                if (res.code !== 1) {
                    MessageBox.alert(res.obj.errmsg, '提示').then(() => {
                    });
                }
                return Promise.reject(res)
            }
        }

        return response;
    },
    (error) => {
        console.log(error.response); // for debug
        const { response } = error;
        if(!response.status){
            Message.error('请求超时');
            return Promise.reject(error);
        }
        if (response.status === 500) {
            const msg = response.data.message;
            if(response.config.url.indexOf('api/user/getModuleList')>=0){
                MessageBox.alert('请求错误，请重新登录', '提示').then(() => {
                    router.push({ path: '/' })
                });
                return;
            }
            if (msg && msg !== 'No message available') {
                Message.error(msg);
            } else {
                // Message.error('网络连接失败[' + response.data.error + ']').then(() => {
                //     location.reload()
                // });
                MessageBox.alert('网络连接失败[' + response.data.error + ']', '提示',{confirmButtonText:'重试',showCancelButton:true}).then(() => {
                    location.reload()
                });
            }
            return Promise.reject(error);
        }
        if (parseInt(response.status / 400) === 1) {
            MessageBox.alert(response.statusText, '提示');
        }
        return Promise.reject(error);
    },
);
const get = (api, data) => {
    const self = this;
    if (data) {
        api += "?" + qs.stringify(data);
    }
    return service.get(api);
}
const post = (api, data) => {
    const self = this;
    return service.post(api, data)
}
const put = (api, id, data) => {
    const self = this;
    return service.put(api + '?id=' + id, data);
}
const del = (api, id) => {
    const self = this;
    return service.delete(api + '?id=' + id);
}
const upload = (api, data, headers) => {
    return service.post(api, data, headers)
}
export default {
    get, post, put, del, upload
};


// WEBPACK FOOTER //
// ./src/utils/httpRequest.js